export default "__VITE_ASSET__D5fDDDja__"